module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQHistoryTitle: 'Vos résultats Color IQ enregistrés',
        colorIQHistoryDesc: 'Vous pouvez obtenir un nouveau balayage Color IQ en visitant votre magasin Sephora le plus proche.',
        latest: 'ACTUEL',
        captured: 'Capturé',
        gotIt: 'Compris',
        viewAll: 'Voir tout'
    };

    return resources[label];
};
